import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import { IncidentDetailsInitialResponseType } from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/initial/getIncidentDetailsInitialQuery.types';
import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi.ts';

const incidentDetailsCardInitialDataGenerator = (
  data: IncidentDetailsInitialResponseType,
): DetailCardItemData[] => [
  {
    type: 'default',
    keyName: 'استان - شهر',
    value: `${data?.visit_county.name}, ${data?.visit_province.name}`,
    hasBullet: true,
  },

  {
    type: 'default',
    keyName: 'تاریخ تشکیل:',
    value: convertTimestampToShamsi(data?.creation_date),
    hasBullet: true,
  },
  {
    type: 'default',
    keyName: 'بیمه‌گر',
    value: data?.insurance.fa_const,
    hasBullet: true,
  },
  {
    type: 'default',
    keyName: 'شعبه بیمه‌گر',
    value: data?.insurance_branch,
    hasBullet: true,
  },
];

export default incidentDetailsCardInitialDataGenerator;
